import './Agreement.css';

const PublicOffer: React.FC = () => {
    return (
        <div className="agreement">
            <p>
                <strong>Договор публичной оферты об оказании услуг</strong><br/><br/>
                
                ИП Осипова Мария Александровна (далее — Исполнитель) предлагает договор публичной оферты для физических и юридических лиц (далее — Заказчик) о нижеследующем.<br/><br/>
                
                <strong>1. Термины и определения</strong><br/>
                1.1. Оферта — документ «Договор публичной оферты об оказании услуг», опубликованный на сайте Исполнителя https://Miartcom.com.<br/>
                1.2. Договор Оферты — договор между Исполнителем и Заказчиком об оказании услуг, который заключается через Акцепт Оферты.<br/>
                1.3. Акцепт Оферты — принятие Оферты Заказчиком, когда он обращается к Исполнителю за оказанием услуг. Акцептом Оферты считается нажатие Заказчиком кнопки «Оплата» под сформированным заказом на сайте https://Miartcom.com.<br/>
                1.4. Тарифы — перечень услуг Исполнителя с ценами, указанными на странице событий на сайте https://Miartcom.com.<br/>
                1.5. Заказчик — лицо, совершившее Акцепт Оферты.<br/>
                1.6. Исполнитель — ИП Осипова Мария Александровна.<br/>
                1.7. Договор не требует скрепления печатями и/или подписания Заказчиком и Исполнителем.<br/><br/>
                
                <strong>2. Предмет Договора</strong><br/>
                2.1. Исполнитель оказывает Заказчику услуги в соответствии с условиями Договора Оферты и текущими Тарифами, опубликованными на сайте https://Miartcom.com.<br/>
                2.2. Заказчик принимает услуги Исполнителя и полностью их оплачивает.<br/>
                2.3. Если Заказчик оставляет отзыв о приобретенных услугах в соцсетях Исполнителя или на его сайте, он дает согласие на размещение персональных данных в отзывах: имени и фамилии.<br/>
                2.4. Заказчик соглашается, что совершая Акцепт Договора, он подтверждает, что ознакомлен, согласен, полностью и безоговорочно принимает все условия Договора Оферты.<br/><br/>
                
                <strong>3. Срок действия Договора</strong><br/>
                3.1. Договор вступает в силу со дня акцепта Заказчиком и действует до полного исполнения сторонами обязательств по Договору.<br/><br/>
                
                <strong>4. Стоимость работ и порядок расчетов</strong><br/>
                4.1. Стоимость услуг определяется в соответствии с действующими ценами и прописана на сайте https://Miartcom.com.<br/>
                4.2. Оплата производится в рублях перечислением на расчетный счет Исполнителя или платежной картой на сайте https://Miartcom.com.<br/><br/>
                
                <strong>5. Права и обязанности</strong><br/>
                5.1. Исполнитель обязуется:<br/>
                5.1.1. Оказать Заказчику услуги надлежащего качества в надлежащем объеме и в согласованные Сторонами сроки.<br/>
                5.1.2. Обеспечить полную сохранность предоставленных Заказчиком данных, материалов, а также конфиденциальность информации, полученной им в процессе оказания услуг.<br/>
                5.2. Исполнитель имеет право:<br/>
                5.2.1. Получать от Заказчика необходимые данные и информацию для оказания услуг и полагаться на них без дополнительной проверки.<br/>
                5.2.2. При необходимости привлекать к исполнению услуг сторонних консультантов, специалистов и экспертов.<br/>
                5.3. Заказчик обязуется:<br/>
                5.3.1. Предоставить Исполнителю любые необходимые и достоверные данные и информацию для оказания услуг.<br/>
                5.3.2. Своевременно и полностью оплатить услуги Исполнителя.<br/><br/>
                
                <strong>6. Основания и порядок расторжения Договора</strong><br/>
                6.1. После оформления и оплаты заказа Заказчик имеет право отказаться от услуг Исполнителя и запросить возврат денег, направив письменное уведомление «Отказ от предоставления услуг» на адрес электронной почты C100mm@mail.ru.<br/>
                6.2. Исполнитель вправе удержать из уплаченной Заказчиком суммы стоимость уже оказанных услуг на момент получения уведомления об отказе.<br/><br/>
                
                <strong>7. Разрешение споров</strong><br/>
                7.1. Споры и разногласия по вопросам исполнения Договора разрешаются на переговорах.<br/>
                7.2. Если на переговорах Стороны не смогут достичь согласия, спор передается в суд.<br/><br/>
                
                <strong>8. Реквизиты</strong><br/>
                Исполнитель:<br/>
                ИП Осипова Мария Александровна<br/>
                192071, Санкт-Петербург г, Славы пр-кт, дом № 20, квартира 102<br/>
                ИНН 781696986441<br/>
                ОГРНИП 314784704200170<br/>
                Р/с: 40802810755000077620<br/>
                Банк: ПАО Сбербанк<br/>
                К/с: 30101810500000000653<br/>
                БИК: 044030653<br/><br/>
                
                Адрес электронной почты: C100mm@mail.ru<br/>
                Тел.: +7 911 901-90-00<br/><br/>
                
                <strong>ИП Осипова Мария Александровна</strong><br/>
                Осипова М.А.<br/>
            </p>
        </div>
    );
};

export default PublicOffer;